const $ = jQuery;

(function($){
    // If clicked on a link with /register/ in the href, add UTM parameters to the URL
    $('a[href*="/register"]').on('click', function(e) {
        e.preventDefault();
        const $link = $(this);
        const href = $link.attr('href');

        // Get UTM params from cookies
        const utmParamsRaw = Cookies.get('dpi_utmVals');

        // If there are no UTM params, return
        if (!utmParamsRaw) {
            window.location.href
            return;
        }

        // Parse the UTM params
        const utmParamsParsed = JSON.parse(utmParamsRaw);

        const utmParams = {
            utm_source: utmParamsParsed.UTM_Source__c,
            utm_medium: utmParamsParsed.UTM_Medium__c,
            utm_campaign: utmParamsParsed.UTM_Campaign__c,
        };

        const url = new URL(href, window.location.origin);

        Object.keys(utmParams).forEach(key => {
            url.searchParams.set(key, utmParams[key]);
        });

        window.location.href = url.href;
    });
})(jQuery);
